import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useLoginPresenter } from './Login.presenter';
import { ILoginProps } from './Login.types';

export const Login: FC<ILoginProps> = observer((props) => {
  const presenter = useLoginPresenter(props);

  const View = presenter.loginCurrentView;

  if (!View) {
    return null;
  }

  return <View loginPresenter={presenter} />;
});
